<template>
  <div class="menu-item">
    <a
      class="menu-item__link"
      :href="item.url"
    >
      <responsive-image
        v-if="item.navigation_icon"
        class="menu-item__image"
        :image="{
          src: item.navigation_icon
        }"
        min-max="80-200"
      />

      <span
        class="text-body-xl-regular text-body-l-regular-desktop text-link-hover"
        v-text="title"
      />

      <product-badge
        v-if="badge"
        :text="liquid.labels[`${badge}`]"
        :class="`product-badge--${badge}`"
      />
    </a>
  </div>
</template>

<script>

/**
 * Vue: Menu item (menu-item)
 * -----------------------------------------------------------------------------
 * Menu item with optional badge.
 *
 */
import ResponsiveImage from '~global/images/responsive-image'

import ProductBadge from '~async/product-badge/product-badge'

export default {
  name: 'MenuItem',

  components: {
    ProductBadge,
    ResponsiveImage,
  },

  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    liquid: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      title: this.item.title.split('|')[0],
      badge: this.item.title.split('|')[1],
    }
  },

  computed: {
    badgeText() {
      const badge = this.badge.replace(/\s/g, '')
      return this.liquid.settings[`${badge.toLowerCase()}_badge_label`]
    },

  },
}
</script>

<style lang="scss">
@import './menu-item';
</style>
